import makeStyles from '@mui/styles/makeStyles'

export const useStyles = makeStyles(
  ({ palette, typography, customShadows, spacing, breakpoints }) => ({
    popover: {
      [breakpoints.up('sm')]: {
        width: 350
      }
    },
    container: {
      padding: spacing(3)
    }
  })
)
